import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import firebase, { auth } from "../../lib/firebase";
import Utils from "../../Utils";
import ar from "../../locale";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
moment.locale("en");

export default class MatchScheduler extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    let curdate = this.props.on ? moment(this.props.on).toDate() : new Date();
    this.state = {
      user: context.user,
      clubs: [],
      token: null,
      loading: false,
      on: curdate.getTime(),
      selecteddate: curdate,
      team1: this.props.team1 || null,
      team2: null,
    };
    this.clubRef = firebase.database().ref("clubs/");
    this.matchRef = firebase.database().ref("matches/");
  }

  componentDidMount() {
    super.componentDidMount();
    auth.currentUser.getIdToken().then((token) => {
      this.state.token = token;
      this.updateState();
    });
    this.clubRef.on("value", (response) => {
      let allClubs = response.val();
      if (this.props.team1) {
        delete allClubs[this.props.team1.key];
      }
      this.state.clubs = Utils.convertToArrayWithInsertionOrder(allClubs);
      this.updateState();
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    this.clubRef.off("value");
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  handleChange = (key, value) => {
    if (key === "on") {
      let on = moment(value);
      on.locale("en");
      this.state.selecteddate = value;
      this.state[key] = on.toDate().getTime();
    } else {
      this.state[key] = value;
    }
    this.updateState();
  };

  onSave = () => {
    let { team1, team2, on } = this.state;
    if (team1 && team2 && on) {
      this.state.loading = true;
      this.updateState();
      let matchKey = this.matchRef.push().key;
      this.matchRef
        .child(matchKey)
        .set({
          finished: false,
          finished_timestamp: null,
          key: matchKey,
          on: on,
          started: false,
          started_timestamp: null,
          team1: team1.key,
          team1_avatar: team1.avatar,
          team1_name: team1.name,
          team1_score: 0,
          team2: team2.key,
          team2_avatar: team2.avatar,
          team2_name: team2.name,
          team2_score: 0,
          winner: null,
        })
        .then((res) => {
          this.showSuccess(ar.operation_successful);
          this.state.loading = false;
          this.updateState();
        })
        .catch((error) => {
          this.showError(error.message);
          this.state.loading = false;
          this.updateState();
        });
    } else {
      this.showError(ar.please_fill_all_options);
    }
  };

  render() {
    let { loading, clubs } = this.state;
    return (
      <div className="container-fluid p-4 bg-light">
        <div className="row">
          <div className="col-12 mt-3">
            {!this.props.team1 && (
              <Select
                isMulti={false}
                onChange={this.handleChange.bind(this, "team1")}
                options={clubs}
                isSearchable={true}
                placeholder={ar.select_club}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option}`}
              />
            )}
            {this.props.team1 && (
              <div className="d-flex flex-row justify-content-center align-items-center">
                <img
                  src={this.props.team1.avatar}
                  className="avatarc m-1"
                  width="50"
                  height="50"
                  alt="avatar"
                />
                <h5 className="m-1">{this.props.team1.name}</h5>
              </div>
            )}
          </div>
          <div className="col-12 mt-3 d-flex flex-row justify-content-center">
            <img src="/assets/images/vs.png" height="50" alt="Versus" />
          </div>
          <div className="col-12 mt-3">
            <Select
              isMulti={false}
              onChange={this.handleChange.bind(this, "team2")}
              options={clubs}
              isSearchable={true}
              placeholder={ar.select_club}
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option}`}
            />
          </div>
          <div className="col-12 mt-3">
            <DatePicker
              selected={this.state.selecteddate}
              dateFormat="MMMM d, yyyy h:mm aa"
              onChange={this.handleChange.bind(this, "on")}
              placeholderText={ar.match_schedule}
              minDate={new Date()}
              showTimeSelect
            />
          </div>
          <div className="col-12 mt-3">
            {!loading && (
              <button
                className="btn btn-info btn-rounded min-w100"
                onClick={this.onSave}
              >
                {ar.save}
              </button>
            )}
            {loading && (
              <button className="btn btn-info btn-rounded min-w100">
                <span
                  className="d-inline-block spinner-border spinner-border-sm text-white"
                  role="status"
                ></span>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
